import Home from "./screens/Home"
import * as React from "react";
import { LanguageContext, LocalizationModule } from "./utilities/LocalizationModule";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { Routes, Route } from "react-router-dom";
import { authRequest } from "./utilities/authConfig";
import Loading from "./components/Loading";
import MessageScreen from "./screens/MessageScreen";
import { DefaultButton } from "@fluentui/react";
import dayjs from 'dayjs';
import 'dayjs/locale/nl'; // import locale
import 'dayjs/locale/de';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import Auth from "./components/displays/Auth";
import Consent from "./components/displays/Consent";
dayjs.extend(localizedFormat);

const AuthLoading: React.FC = () => {
    const languageStrings = React.useContext(LanguageContext);
    return <Loading label={languageStrings.SignInRequest} />;
};

const AuthError: React.FC = () => {
    const languageStrings = React.useContext(LanguageContext);
    const actionButton = <DefaultButton
        onClick={() => {
            window.location.reload();
        }}>
        {languageStrings.TryAgain}
    </DefaultButton>
    return <MessageScreen text={languageStrings.AuthFailed} actionButton={actionButton} />;
};

const App: React.FC = () => {
    const languageStrings = LocalizationModule.getLocaleStrings();
    return (
        <LanguageContext.Provider value={languageStrings}>
            <Routes>
                {/* Public OAuth landing pages — must stay OUTSIDE the MSAL gate; they run
                    before/independent of an account and read window.location.search. They
                    out-rank "/*" by route specificity. */}
                <Route path="/auth" element={<Auth />} />
                <Route path="/consent" element={<Consent />} />
                <Route
                    path="/*"
                    element={
                        <MsalAuthenticationTemplate
                            interactionType={InteractionType.Redirect}
                            authenticationRequest={authRequest}
                            errorComponent={AuthError}
                            loadingComponent={AuthLoading}>
                            <Home />
                        </MsalAuthenticationTemplate>
                    }
                />
            </Routes>
        </LanguageContext.Provider>
    );
};

export default App;